export const fieldMappings = {
    'borough':'connect',
    'distributor':'connect',
    'panels':'create',
    'panels.pack':'connect',
    'panels.panelAvailabilities':'create',
    'panels.postInstruction':'connect',
    'region':'connect',
    'siteBuildAndRepairs':'create',
    'siteBuildAndRepairs.buildType':'connect',
    'siteBuildAndRepairs.buildContractor':'connect',
    'siteHealthAndSafeties':'create',
    'siteHealthAndSafeties.healthAndSafetyType':'connect',
    'siteMaintenanceInspection':'create',
    'siteMaintenanceInspection.siteMaintenanceInspectionType':'connect',
    'siteDigitalBookingPricing':'create',
    'sitePlannings.planningStage':'connect',
    'sitePlannings.planningOutcome':'connect',
    'sitePricing':'connect',
    'siteRentals':'create',
    'siteRentals.paymentFrequency':'connect',
    'siteRentals.paymentMethod':'connect',
    'siteRentals.rentalType':'connect',
    'siteStructure':'connect',
    'siteStructureType':'connect',
    'subletter':'connect',
    'style':'connect',
    'tvarea':'connect',
    'tags':'connect'
};